import { useQuery } from '@tanstack/react-query';
import type { Funding } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const fundingCampaignQueryKey = (campaignId: string) =>
  ['admin', 'funding-campaign', campaignId] as const;

export const useFundingCampaignQuery = (campaignId: string | undefined) =>
  useQuery<Funding>({
    queryKey: fundingCampaignQueryKey(campaignId ?? ''),
    enabled: Boolean(campaignId),
    queryFn: async () => {
      const [data] = await apiClient.request(
        'get',
        '/admin/v1/funding-campaigns/{campaignId}',
        { params: { path: { campaignId: campaignId as string } } },
      );
      return data as Funding;
    },
  });
